import { registerEntityEndpoint as e } from "@editor/ui-utils";
//#region src/services/ab-test.service.ts
var t = e("AbTesting", "/cms/ab-testing"), { listEntities: n } = t, r = e("AbTestingGrouped", "/cms/ab-testing/grouped"), i = e("AbTestContents", "/cms/contents"), a = e("AbTestChannels", "/cms/channels");
async function o(e) {
	return n({ params: e });
}
async function s(e) {
	return i.getEntity(e);
}
async function c(e) {
	if (e) return a.getEntity(e);
}
async function l(e) {
	await t.getEntityAPIClient().post(`${e}/end`);
}
async function u(e) {
	return t.postEntity(e);
}
async function d(e) {
	await t.getEntityAPIClient().post(`${e}/start`);
}
async function f(e) {
	await t.deleteEntity(e);
}
async function p(e, t) {
	let r = {
		contentUuid: e,
		sortBy: "createDate",
		sortDesc: "true"
	};
	return t && (r.state = t), n({ params: r });
}
//#endregion
//#region \0plugin-vue:export-helper
var m = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, h = (e) => e === "running" || e === "notStarted", g = (e) => {
	if (e.state !== "completed") return !1;
	let t = e.variants ?? [];
	return t.length === 0 ? !1 : !t.some((e) => e.isWinner);
}, _ = (e, t) => ({
	running: t("abTesting.stateRunning"),
	completed: t("abTesting.stateCompleted"),
	canceled: t("abTesting.stateCanceled"),
	notStarted: t("abTesting.stateNotStarted")
})[e], v = (e, t) => g(e) ? t("abTesting.stateCompletedNoWinner") : _(e.state, t), y = (e) => ({
	running: "text-positive text-weight-medium",
	completed: "text-grey-8",
	canceled: "text-grey-6",
	notStarted: "text-warning text-weight-medium"
})[e];
//#endregion
export { v as a, f as c, p as d, s as f, d as h, y as i, l, r as m, h as n, m as o, c as p, _ as r, u as s, g as t, o as u };

//# sourceMappingURL=ab-test.utils-YxSoNfxm.js.map